export default "__VITE_ASSET__676e33f1__"